import { render, staticRenderFns } from "./CederAsientoDetalle.vue?vue&type=template&id=8c6c5406"
import script from "./CederAsientoDetalle.vue?vue&type=script&setup=true&lang=js"
export * from "./CederAsientoDetalle.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports